const styles = {
  container: {
    height: '90%',
  },
  chip: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    flex: 1,
    '& .MuiChip-label': { flex: 1 },
  },
};

export default styles;
